/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AgentResource { 
    /**
     * Resource Id
     */
    id: string;
    /**
     * Resource name
     */
    display_name: string;
    /**
     * Resource FQDN
     */
    fqdn: string;
}

